import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import {HoverStyles, TextButton, TextButtonPriority} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Star} from '../../../../../../icons/Star'
import {StarFilled} from '../../../../../../icons/StarFilled'
import {PersonalAgendaOrigin} from '../../../actions/schedule'
import {useWidgetProps} from '../../../hooks/widget-props'
import s from './my-agenda-button.scss'
import {classes as c} from './my-agenda-button.st.css'

export const MyAgendaButton = () => {
  const {bookmarksCount, t, viewPersonalAgenda} = useWidgetProps()
  const {isMobile} = useEnvironment()

  return (
    <TextButton
      data-hook={DH.MY_AGENDA_BUTTON}
      className={classNames(c.button, s.button, {
        [s.mobile]: isMobile,
      })}
      prefixIcon={bookmarksCount ? <StarFilled className={s.starFilled} /> : <Star className={s.star} />}
      priority={TextButtonPriority.primary}
      hoverStyle={HoverStyles.underline}
      onClick={() => viewPersonalAgenda({origin: PersonalAgendaOrigin.Schedule})}
    >
      {t('myAgenda.viewButton', {count: bookmarksCount})}
    </TextButton>
  )
}
